export enum DialogSize {
  TINY = 'TINY',
  SMALL = 'SMALL',
  LARGE = 'LARGE',
  FULL_SCREEN = 'FULL_SCREEN',
}

export const DIALOG_FADE_DURATION = 300;
